import React from "react";
import { getCurrentDate } from "store/utils";
import { useTranslation } from "react-i18next";

import { useFormContext, Controller } from "react-hook-form";
import DocumentUploader from "components/common/DocumentUploader";
import { Box, TextField, Typography, Grid, Paper, Stack } from "@mui/material";

const DocumentInfo = () => {
  const {
    register,
    formState: { errors },
    control,
  } = useFormContext();
  const { t } = useTranslation();

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6">
        {t("auth.signup.sections.documents")}
      </Typography>

      <Paper elevation={1} sx={{ bgcolor: "transparent", p: 2, mt: 2 }}>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Stack gap={2.5}>
              <Controller
                control={control}
                name="logo_image"
                rules={{
                  required: t("auth.common.requiredField"),
                }}
                render={({ field, fieldState }) => (
                  <DocumentUploader
                    label={t("auth.signup.documents.companyLogo")}
                    file={field.value}
                    onFileChange={(file) => field.onChange(file)}
                    error={fieldState.error?.message}
                  />
                )}
              />
            </Stack>
          </Grid>

          <Grid size={{ xs: 12, sm: 6 }}>
            <Stack gap={2.5}>
              <Controller
                control={control}
                name="banner_image"
                render={({ field }) => (
                  <DocumentUploader
                    label={t("auth.signup.documents.bannerImage")}
                    file={field.value}
                    onFileChange={(file) => field.onChange(file)}
                  />
                )}
              />
            </Stack>
          </Grid>

          <Grid size={{ xs: 12, sm: 6 }}>
            <Stack gap={2.5}>
              <Controller
                control={control}
                name="company_registration"
                rules={{
                  required: t("auth.common.requiredField"),
                }}
                render={({ field, fieldState }) => (
                  <DocumentUploader
                    label={t("auth.signup.documents.companyRegistration")}
                    file={field.value}
                    onFileChange={(file) => field.onChange(file)}
                    error={fieldState.error?.message}
                  />
                )}
              />

              <TextField
                label={t("auth.signup.fields.crNumber.label")}
                fullWidth
                {...register("cr_number", {
                  required: t("auth.signup.fields.crNumber.required"),
                })}
                sx={{ mt: 1 }}
                error={Boolean(errors.cr_number)}
                helperText={errors.cr_number?.message}
              />
              <TextField
                label={t("auth.signup.fields.crExpiry.label")}
                fullWidth
                type="date"
                defaultValue={getCurrentDate()} // Set today's date as default
                {...register("cr_expiry", {
                  required: t("auth.signup.fields.crExpiry.required"),
                })}
                inputProps={{
                  min: new Date().toISOString().split("T")[0], // Set today's date as minimum
                }}
                error={Boolean(errors.cr_expiry)}
                helperText={errors.cr_expiry?.message}
              />
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Stack gap={2.5}>
              <Controller
                control={control}
                name="vat_image"
                rules={{
                  required: t("auth.common.requiredField"),
                }}
                render={({ field, fieldState }) => (
                  <DocumentUploader
                    label={t("auth.signup.documents.vatDocument")}
                    file={field.value}
                    onFileChange={(file) => field.onChange(file)}
                    error={fieldState.error?.message}
                  />
                )}
              />

              <TextField
                label={t("auth.signup.fields.vatNumber.label")}
                fullWidth
                {...register("vat_number", {
                  required: t("auth.signup.fields.vatNumber.required"),
                })}
                sx={{ mt: 1 }}
                error={Boolean(errors.vat_number)}
                helperText={errors.vat_number?.message}
              />
              <TextField
                label={t("auth.signup.fields.vatExpiry.label")}
                fullWidth
                defaultValue={getCurrentDate()} // Set today's date as default
                type="date"
                {...register("vat_expiry", {
                  required: t("auth.signup.fields.vatExpiry.required"),
                })}
                inputProps={{
                  min: new Date().toISOString().split("T")[0], // Set today's date as minimum
                }}
                error={Boolean(errors.vat_expiry)}
                helperText={errors.vat_expiry?.message}
              />
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Stack gap={2.5} mb={2}>
              <Controller
                control={control}
                name="contract_image"
                // rules={{
                //     required: t("auth.common.requiredField"),
                // }}
                render={({ field, fieldState }) => (
                  <DocumentUploader
                    label={t("auth.signup.documents.contractDocument")}
                    file={field.value}
                    onFileChange={(file) => field.onChange(file)}
                    error={fieldState.error?.message}
                  />
                )}
              />
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Stack gap={2.5}>
              <Controller
                control={control}
                name="owner_id"
                // rules={{
                //     required: t("auth.common.requiredField"),
                // }}
                render={({ field, fieldState }) => (
                  <DocumentUploader
                    label={t("auth.signup.documents.ownerId")}
                    file={field.value}
                    onFileChange={(file) => field.onChange(file)}
                    error={fieldState.error?.message}
                  />
                )}
              />
            </Stack>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default DocumentInfo;
